// ---------------------------------------------------------------------------------

const MYPRO_ERROR = resolve => require(['../components/views/_error'], resolve);
// 正常下载
const MYPRO_APPSDOWN = resolve => require(['../components/views/appsdown'], resolve);
// 绑定授权
const MYPRO_BINDDOWN = resolve => require(['../components/views/binddown'], resolve);
// 扫码绑定
const MYPRO_AUTHBIND = resolve => require(['../components/views/scanbind'], resolve);

const MYPRO_EXTDOWN = resolve => require(['../components/views/tg-bind'], resolve);
const MYPRO_CHANNEL = resolve => require(['../components/views/tg-edata'], resolve);


const funcs = [
  {
    path: '/error/:id',
    name: 'MYPRO-ERROR',
    component: MYPRO_ERROR,
  },
  {
    path: '/appdown/:dtype?/:sid?/:duid?',
    name: 'MYPRO-APPSDOWN',
    component: MYPRO_APPSDOWN,
  },
  {
    path: '/authdown/:store/:uuid',
    name: 'MYPRO-BINDDOWN',
    component: MYPRO_BINDDOWN,
  },
  {
    path: '/scbind/:store/:uuid?',
    name: 'MYPRO-AUTHBIND',
    component: MYPRO_AUTHBIND,
  },
  {
    path: '/extdata/:cuid?',
    name: 'MYPRO-CHANNEL',
    component: MYPRO_CHANNEL,
  },
  {
    path: '/extdown/:type?/:uuid?/:sign?',
    name: 'MYPRO-EXTDOWN',
    component: MYPRO_EXTDOWN,
  },
  // 一定要在最后
  {
    path: '*',
    component: 404,
    meta: { requiresAuth: true }
  }
];

export default funcs;



// WEBPACK FOOTER //
// ./src/vuex/menus.js